var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-toolbar', {
    attrs: {
      "id": "core-toolbar",
      "text": "",
      "flat": ""
    }
  }, [_c('v-toolbar-items', [_vm.responsive ? _c('v-btn', {
    attrs: {
      "text": "",
      "icon": ""
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.onClickBtn.apply(null, arguments);
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-menu")])], 1) : _vm._e()], 1), _c('helper-loading'), _vm.getWhiteLabel ? _c('v-menu', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "offset-y": "",
      "right": "",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "disabled": _vm.$apollo.loading,
            "outlined": "",
            "small": "",
            "text": ""
          }
        }, on), [_vm._v(" " + _vm._s(_vm.getWhiteLabel.name) + " ")])];
      }
    }], null, false, 2479480501)
  }, [_c('v-sheet', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.whiteLabels, function (w, i) {
    return _c('v-list-item', {
      key: i,
      attrs: {
        "dense": ""
      },
      on: {
        "click": function click($event) {
          return _vm.setWhiteLabel(w);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(w.name))])], 1);
  }), 1)], 1) : _vm._e(), _c('v-spacer'), _vm.me === undefined && !_vm.getUser && !_vm.$apollo.loading ? _c('v-toolbar-items', [_c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [!_vm.$vuetify.breakpoint.xs ? _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push('/login');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("register.logIn")) + " ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm.me !== undefined || _vm.getUser ? _c('v-toolbar-items', [_c('v-flex', {
    attrs: {
      "align-center": "",
      "layout": "",
      "py-2": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "nudge-width": 270,
      "offset-y": "",
      "left": "",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_vm.getUser && _vm.getUser.avatar != null || _vm.me && _vm.me.avatar != null ? _c('v-avatar', _vm._g({
          staticStyle: {
            "cursor": "pointer",
            "border": "1px solid #f6f8f9"
          },
          attrs: {
            "tile": false,
            "size": 40
          }
        }, on), [_c('v-img', {
          attrs: {
            "src": _vm.me ? _vm.me.avatar : _vm.getUser.avatar,
            "lazy-src": _vm.me ? _vm.me.avatar : _vm.getUser.avatar,
            "max-height": "40",
            "contain": ""
          }
        })], 1) : _c('v-avatar', _vm._g({
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "tile": false,
            "size": 40,
            "color": _vm.$vuetify.theme.dark ? _vm.$vuetify.theme.themes.dark.surface : _vm.$vuetify.theme.themes.light.surface
          }
        }, on), [_c('strong', [_c('a', [_vm._v(_vm._s(_vm._f("substring")(_vm._f("uppercase")(_vm.me ? _vm.me.name : _vm.getUser.name), 0, 2)))])])])];
      }
    }], null, false, 2901921717)
  }, [_c('v-card', {
    staticClass: "me-info-card"
  }, [_c('v-sheet', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    staticClass: "me-info"
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.me ? _vm.me.name : _vm.getUser.name))]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.me ? _vm.me.obfuscated_email : _vm.getUser.obfuscated_email) + " "), _c('br'), _c('v-chip', {
    staticClass: "mt-3",
    attrs: {
      "small": "",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.depositfunds.open();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("toolbar.myBalance")) + ": "), _c('b', [_vm._v(" " + _vm._s(_vm.usdAmount) + " USD")])])], 1)], 1), _c('v-list-item-action', {
    staticClass: "text-right"
  }, [_c('v-btn', {
    staticClass: "ml-3",
    attrs: {
      "x-small": "",
      "text": "",
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.depositfunds.open();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("globals.depositButton")) + " ")])], 1)], 1), _c('v-divider'), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/profile');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-account-circle-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("toolbar.myProfile")) + " ")])], 1)], 1), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/security');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-shield-account-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("toolbar.security")) + " ")])], 1)], 1), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/myinvoices');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-text-box-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("toolbar.myInvoices")) + " ")])], 1), _vm.me && _vm.me.unpaid_invoices || _vm.getUser && _vm.getUser.unpaid_invoices ? _c('v-list-item-action', [_c('v-icon', [_vm._v(" mdi-alert-circle ")])], 1) : _vm._e()], 1), _vm.getWhiteLabel ? _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/affplans');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-vector-triangle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("toolbar.affiliatePlans")) + " ")])], 1)], 1) : _vm._e(), _vm.getWhiteLabel && _vm.isOwner ? _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/gateways');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-credit-card-outline")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("whitelabel.paymentSettings")) + " ")])], 1)], 1) : _vm._e(), _vm.getWhiteLabel && _vm.isOwner ? _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/members');
      }
    }
  }, [_c('v-list-item-icon', [_c('IconCustom', {
    attrs: {
      "name": "icn24_users",
      "color": _vm.$vuetify.theme.dark ? '#FFFFFF' : '#7F97AB'
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("members.title")) + " ")])], 1), _c('v-list-item-action', [_c('v-chip', {
    attrs: {
      "small": "",
      "color": _vm.$vuetify.theme.dark ? '#FFFFFF' : '#7F97AB',
      "text-color": "rgba(0, 0, 0, 0.87)"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("globals.beta")) + " ")])], 1)], 1) : _vm._e(), _vm.getWhiteLabel && _vm.isOwner ? _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/modules/configuration');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-apps")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("whitelabel.modulesSettings")) + " ")])], 1)], 1) : _vm._e(), _vm.isTariffs && !_vm.getIsSharingWhitelabels ? _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/tariffs');
      }
    }
  }, [_c('v-list-item-icon', [_c('IconCustom', {
    attrs: {
      "name": "icn20_coupon_2",
      "color": _vm.$vuetify.theme.dark ? '#FFFFFF' : '#7F97AB'
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("whitelabel.tariffSettings")) + " ")])], 1)], 1) : _vm._e(), _vm.chatIDExists ? _c('v-list-item', {
    on: {
      "click": _vm.onEnableLiveChat
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-face-agent")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("toolbar.liveChat")) + " ")])], 1), _c('v-list-item-action', [_c('v-switch', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.showChat,
      callback: function callback($$v) {
        _vm.showChat = $$v;
      },
      expression: "showChat"
    }
  })], 1)], 1) : _vm._e(), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v(" " + _vm._s(_vm.$vuetify.theme.dark ? "mdi-moon-waxing-crescent" : "mdi-weather-sunny") + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("toolbar.darkMode")) + " ")])], 1), _c('v-list-item-action', [_c('v-switch', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    },
    model: {
      value: _vm.$vuetify.theme.dark,
      callback: function callback($$v) {
        _vm.$set(_vm.$vuetify.theme, "dark", $$v);
      },
      expression: "$vuetify.theme.dark"
    }
  })], 1)], 1), _c('v-divider'), _c('v-list-item', {
    on: {
      "click": function click($event) {
        return _vm.$router.push('/login');
      }
    }
  }, [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-power")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.$t("toolbar.logOut")) + " ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _c('helper-deposit-funds', {
    ref: "depositfunds"
  }), _vm.showInvite ? _c('helper-confirm-dialog', {
    attrs: {
      "show-dialog": _vm.showInvite,
      "text": _vm.$t('members.acceptInvate', {
        whitelabel: _vm.dataInvite.whitelabel.name,
        role: _vm.dataInvite.role.name
      })
    },
    on: {
      "closeConfirmDialog": _vm.closeConfirmDialog
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }